module.exports = __webpack_public_path__ + "static/media/400080_02.34098e3f.png";